export const fixOrNotOptions = [
  {
    label: 'Fix',
    value: true
  },
  {
    label: 'Don\'t fix',
    value: false
  }
];
